import {UIComponent} from "@/engine/UI/UIComponent.js";

/** creates UI component 'Tabs'
 *
 */
export class UICTabs extends UIComponent {
    /**
     *
     * @param options {{items: [{item: {name: string, content: string | UIComponent, onSelect: function}}], defaultItem: number}}
     * @param view
     */
    constructor(options, view = "tabsWindowContent") {
        super(options, view);
        this.id = (this.id === undefined) ? 'tabs' : this.id
        this.title = (this.title === undefined) ? 'tablist' : this.title
        this.mainActionName = (this.mainActionName === undefined) ? 'DEFAULT OK' : this.mainActionName
        this.cancelActionName = (this.cancelActionName === undefined) ? 'DEFAULT CANCEL' : this.cancelActionName
        //this.contentDataBindPrefix = this.contentDataBindPrefix || 'tabs'
        this.contentData = this._contentData
        if (this.defaultItem === undefined)
            this.defaultItem = 0
        this._prevSelectedItem = -1
    }

    open(container, parent, data) {
        super.open(container, parent)

        //update tabs elements on changing
        this.containerElement.querySelectorAll(".tabs input[type=radio]").forEach(function (el) {
            el.addEventListener("change", this._onTabChange.bind(this));
            if (el.checked) // for what ?
                el.dispatchEvent(new Event("change"));
        }.bind(this));
    }

    close() {
        if (!this.containerElement)
            return
        this.containerElement.querySelectorAll(".tabs input[type=radio]").forEach(function (el) {
            el.removeEventListener("change", this._onTabChange.bind(this));
        }.bind(this));
        super.close()
    }

    onCancelAction() {
        this.close()
        super.onCancelAction();
        return true
    }

    selectedItem() {
        let radio = this.containerElement.querySelectorAll(".tabs input[type=radio]")
        for (let r of radio) {
            if (r.checked)
                return r.id.substring(this._tabIdPrefix().length) * 1
        }
        return -1
    }

    switchToItem(id) {
        let radio = this.containerElement.querySelector(".tabs input[id='" + this._tabId(id) + "']")
        radio.checked = true
        this._onTabChange({target: radio})
    }

    _contentData() {
        let radioList = []
        let labelList = []
        let contentList = []
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].content instanceof UIComponent) {
                if (!this.items[i].content.validateBeforeOpen())
                    continue
            }
            radioList.push({tabId: this._tabId(i), checked: this.defaultItem === i})
            labelList.push({tabId: this._tabId(i), label: this.items[i].name, picture: this.items[i].picture})
            contentList.push({tabId: this._tabId(i), content: typeof this.items[i].content === 'string' ? this.items[i].content : ''})
        }
        return {
            radioList: radioList,
            labelList: labelList,
            contentList: contentList,
        }
    }

    _tabIdPrefix() {
        return this.id+'-'+'tab'+'-'
    }

    _tabId(id) {
        return this._tabIdPrefix()+id
    }

    _tabContentContainer(id) {
        return this.containerElement.querySelector("section[for='" + this._tabId(id)+ "']")
    }

    _onItemSelect(id) {
        if (this._prevSelectedItem !== id) {
            let container = this._tabContentContainer(id)
            // closes previous tab and "destroy" component
            if (this._prevSelectedItem >= 0) {
                let itemContent = this.items[this._prevSelectedItem].content
                if (itemContent instanceof UIComponent) {
                    itemContent.close()
                }
            }
            // fill item container with UIComponent data
            let itemContent = this.items[id].content
            if (itemContent instanceof UIComponent) {
                itemContent.open(container, this)
            }
            // update dialog buttons if container is L.Control.Window
            if (this.container instanceof L.Control.Window) {
                if (itemContent instanceof UIComponent) {
                    prompt = {
                        buttonOK: itemContent.cancelActionName,
                        buttonAction: itemContent.mainActionName,
                        callback: itemContent.onCancelAction.bind(itemContent),
                        action: itemContent.onMainAction.bind(itemContent)
                    }
                } else {
                    prompt = {
                        buttonOK: this.cancelActionName,
                        buttonAction: this.mainActionName,
                        callback: this.onCancelAction.bind(this),
                        action: this.onMainAction.bind(this)
                    }
                }
                this.container.options.prompt = prompt
                this.container.prompt(this.container.options.prompt)
            }
            if (typeof this.items[id].onSelect === "function") {
                this.items[id].onSelect.bind(this)(id)
            }
        }
        this._prevSelectedItem = id
    }

    _onTabChange(event) {
        let radio = event.target
        let id = radio.id;
        let items = radio.parentNode.querySelectorAll(":scope > ul > li label");
        //let width = Math.floor(100 / items.length);
        items.forEach( function (el) {
            if ((el.getAttribute("for") == id) && radio.checked) {
                el.classList.add("selectedItem");
                let itemNo = id.substring(this._tabIdPrefix().length)
                this._onItemSelect(itemNo * 1)
            } else {
                el.classList.remove("selectedItem");
            }
            //disabled as it breaks a view with nowrap labels and empty content (cut label text)
            //el.parentNode.style.width = width + "%";
        }.bind(this));
        radio.parentNode.querySelectorAll(":scope > .tab-content section").forEach( function (el) {
            if ((el.getAttribute("for") == id) && radio.checked) {
                el.classList.add("selectedItem");
            } else {
                el.classList.remove("selectedItem");
            }
            if (this.container instanceof L.Control.Window) {
                this.container.contentUpdated()
            }
        }.bind(this));
    }
}
